export default "__VITE_ASSET__DCYyIHsS__"